import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import {
	Control,
	Controller,
	FieldValues,
	Path,
	SetFieldValue,
} from "react-hook-form";
import { FaRegCalendar } from "react-icons/fa6";

import moment from "moment";
import "./date_picker.scss";

export type TDatePickerProps<T extends FieldValues> = {
	minDate?: moment.Moment;
	maxDate?: moment.Moment;
	disabled?: boolean;
	placeholder?: string;
	control: Control<T>;
	name: Path<T>;
	setFormValue: SetFieldValue<T>;
};

export function DatePicker<T extends FieldValues>({
	control,
	name,
	minDate,
	maxDate,
	disabled,
	placeholder,
	setFormValue,
}: TDatePickerProps<T>) {
	return (
		<Controller
			control={control}
			name={name}
			render={({ field: { value } }) => {
				return (
					<div className="date-selector-container">
						<LocalizationProvider dateAdapter={AdapterMoment}>
							<DesktopDatePicker
								minDate={minDate}
								maxDate={maxDate}
								disabled={disabled}
								slotProps={{
									textField: {
										variant: "standard",
										InputProps: {
											disableUnderline: true,
											className: "normal-text date-selector",
											...(placeholder ? { placeholder } : {}),
											onBlur: () => {
												if (
													value &&
													value.format("YYYY-MM-DD") !== "Invalid date"
												) {
													if (
														minDate &&
														value
															.hour(0)
															.minute(0)
															.second(0)
															.millisecond(0)
															.isBefore(minDate)
													) {
														setFormValue(name, minDate);
													} else if (
														maxDate &&
														value
															.hour(0)
															.minute(0)
															.second(0)
															.millisecond(0)
															.isAfter(maxDate)
													) {
														setFormValue(name, maxDate);
													}
												}
											},
										},
									},
									inputAdornment: {
										className: "date-selector-icon-container",
									},
									openPickerButton: {
										className: "icon-button",
										sx: {
											padding: 0,
											marginRight: 0,
										},
										disableRipple: true,
									},
								}}
								slots={{
									openPickerIcon: FaRegCalendar,
								}}
								value={value}
								onChange={(newValue) => {
									setFormValue(name, newValue);
								}}
							/>
						</LocalizationProvider>
					</div>
				);
			}}
		/>
	);
}
